export enum TurnaroundTimeTypes {
    withinRange = 1,
    aboveAverage = 2
}